function TopBar() {
  const phoneNumber = "+91-7037733026";
  const email = "terraenvironlabs@gmail.com";

  return (
    <div className="bg-[#16A34A] text-white py-1.5 md:py-2">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4">
          {/* Welcome Message - Left Side */}
          <div className="flex items-center gap-2 text-xs md:text-sm">
            <svg
              className="w-3 h-3 md:w-4 md:h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span className="font-medium">Welcome to Terra Environ Labs</span>
          </div>

          {/* Contact Info - Right Side */}
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4">
            {/* Mobile Number */}
            <a
              href={`tel:${phoneNumber.replace(/\s/g, '')}`}
              className="flex items-center gap-1.5 hover:opacity-80 transition-opacity text-xs md:text-sm"
              aria-label="Call us"
            >
              <svg
                className="w-3.5 h-3.5 md:w-4 md:h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
              <span className="font-medium">{phoneNumber}</span>
            </a>

            {/* Email */}
            <a
              href={`mailto:${email}`}
              className="flex items-center gap-1.5 hover:opacity-80 transition-opacity text-xs md:text-sm"
              aria-label="Email us"
            >
              <svg
                className="w-3.5 h-3.5 md:w-4 md:h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              <span className="font-medium hidden sm:inline">{email}</span>
              <span className="font-medium sm:hidden text-[10px]">Email</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopBar;

